"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRecognizer = void 0;
const react_1 = require("react");
const helpers_1 = require("@app/helpers");
const exercise_1 = require("@app/routes/SpeechDevelopment/reducers/exercise");
var RecognizerModes;
(function (RecognizerModes) {
    RecognizerModes["byWord"] = "byWord";
    RecognizerModes["wholeAnswer"] = "wholeAnswer";
})(RecognizerModes || (RecognizerModes = {}));
;
const useRecognizer = (wordList) => {
    const [recognizerParams, setRecognizerParams] = (0, react_1.useState)(null);
    const [isRecognizing, setIsRecognizing] = (0, react_1.useState)(false);
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const langId = (0, helpers_1.getCurrentLanguage)();
    const isFinished = (0, exercise_1.useSelectIsFinished)();
    (0, react_1.useEffect)(() => {
        if (isFinished)
            stopRecognition();
    }, [isFinished]);
    const stopMediaStream = (0, react_1.useCallback)(() => {
        if (recognizerParams === null || recognizerParams === void 0 ? void 0 : recognizerParams.mediaStream) {
            recognizerParams.mediaStream.getTracks().forEach(t => t.stop());
        }
    }, [recognizerParams]);
    const startRecognition = (0, react_1.useCallback)(() => __awaiter(void 0, void 0, void 0, function* () {
        setIsLoading(true);
        const stream = yield window.navigator.mediaDevices.getUserMedia({
            audio: {
                sampleRate: 16000,
                sampleSize: 16,
                channelCount: 1,
            },
        });
        const recognizerInstance = new window.RecognizerSpeechDev(wordList);
        yield recognizerInstance.init(stream, langId, RecognizerModes.wholeAnswer);
        console.log('recognizer init is ready');
        setIsRecognizing(true);
        setIsLoading(false);
        setRecognizerParams({
            mediaStream: stream,
            recognizerInstance
        });
    }), []);
    const stopRecognition = (0, react_1.useCallback)(() => {
        if (!recognizerParams)
            return;
        document.removeEventListener('recognizeWordEvent', recognizerParams.handler);
        stopMediaStream();
        recognizerParams.recognizerInstance.stop();
        setRecognizerParams(null);
        setIsRecognizing(false);
    }, [recognizerParams]);
    return {
        startRecognition,
        stopRecognition,
        isRecognizing,
        isLoading
    };
};
exports.useRecognizer = useRecognizer;
